export default __webpack_public_path__ + "static/media/cyber-attacks.1704344f.svg";